import generalUpload from "../_section/upload.class";
export class userCVUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [{
        name: 'documentDate',
        label: 'Document Date',
        type: 'date',
    }]
}
export class adminCVUpload extends userCVUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.add(20, 'year'),
            })
        }
    }

}
